import type { ConfigurationEncode } from "../security/configurationEncode";
import { CryptoHelper } from "../security/cryptoHelper";
import { createTokenStorage } from "./tokenStorage";
import {createUserStorage} from "./userStorage";

interface IntegratedAuthStorage {
  user: ReturnType<typeof createUserStorage>;
  tokens: ReturnType<typeof createTokenStorage>;
  removeFromStorage: () => void;
}

export const createIntegratedAuthStorage = (options: {
  userStorageKey: string;
  tokenStorageKey: string;
  encoder?: ConfigurationEncode;
  onTokensSaved?: () => void;
}): IntegratedAuthStorage => {
  const encoder = options.encoder ?? {
    key: "KEYencodeECMABCDEFGHSAGIJKLMNCore",
    keyLength: 32,
    iv: "IVencodeECMABCDEF",
    ivLength: 16,
  };

  const userStorage = createUserStorage({
    storageKey: options.userStorageKey,
    encrypt: true,
    encoder,
  });

  const tokenStorage = createTokenStorage(options.tokenStorageKey, {
    encrypt: (plain) => CryptoHelper.encrypt(encoder, plain),
    decrypt: (cipher) => CryptoHelper.decrypt(encoder, cipher),
  });

  return {
    user: userStorage,
    tokens: tokenStorage,
    removeFromStorage: () => {
      userStorage.clear();
      tokenStorage.clear();
    },
  };
};

export const createCompatibleUserStorage = (options: {
  userStorageKey: string;
  tokenStorageKey: string;
  encoder?: ConfigurationEncode;
  onTokensSaved?: () => void;
}) => {
  const integrated = createIntegratedAuthStorage(options);

  return {
    ...integrated.user,
    removeFromStorage: () => integrated.removeFromStorage(),
    tokens: integrated.tokens,
    
    save: (
      idUsuarioOrData: number | import('./userStorage').UserCredentials,
      nombre?: string,
      apellido?: string,
      apellidoNombre?: string,
      codUsuarioEstado?: number,
      accessToken?: string,
      refreshToken?: string,
      idPerfil?: number,
      codigoArea?: string,
      telefono?: string
    ) => {
      if (typeof idUsuarioOrData === 'object') {
        integrated.user.save(idUsuarioOrData);
        return;
      }

      integrated.user.save({
        userId: idUsuarioOrData,
        firstName: nombre!,
        lastName: apellido!,
        fullName: apellidoNombre!,
        userState: codUsuarioEstado!,
        profileId: idPerfil!,
        areaCode: codigoArea,
        phoneNumber: telefono,
      });

      if (accessToken && refreshToken) {
        integrated.tokens.save(accessToken, refreshToken);
      }
    },
  };
};



